import { render, staticRenderFns } from "./PriceConfigDeleteForm.vue?vue&type=template&id=861f5e8e&"
import script from "./PriceConfigDeleteForm.vue?vue&type=script&lang=ts&"
export * from "./PriceConfigDeleteForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports